<template>
  <div id="salemarket">
    <my-header></my-header>
    <div class="pd20">
      <div class="sale-market" v-if="search_params.store_id">
        <sale-market-head></sale-market-head>
        <div v-if="store">
          <h4 class="inline">
            <i class="fas fa-store-alt"></i>
            {{store.name}}
          </h4>&nbsp;&nbsp;
        </div>
        <div class="row mt40">
          <div class="col-md-3">
            <p>
              <router-link
                :to="{ name: 'ProfileStore', params: { storeId: search_params.store_id}}"
              >
                <i class="far fa-id-card"></i>
                {{'View profile'|translate}}
              </router-link>
            </p>

            <favorite-control :storeId="search_params.store_id"></favorite-control>
            <p v-if="store && store.commune_name">
              <i class="fas fa-map-marker"></i>
              {{ store.commune_name }},{{ store.district_name }},{{ store.province_name }}
            </p>
            <form v-on:submit.prevent="formDoSearch" class="mt20">
              <!-- <h4 class="mt0">{{'Filter'|translate}}</h4> -->
              <div class="row">
                <div class="col-md-12 col-xs-12 col-sm-6">
                  <div class="form-group">
                    <select
                      class="form-control"
                      v-model="search_params.product_id"
                      @change="onSelectProduct"
                    >
                      <option value>{{'All products'|translate}}...</option>
                      <option
                        v-for="item in allProducts"
                        :value="item.id"
                        :key="item.id"
                      >{{ item.name }}</option>
                    </select>
                  </div>
                </div>

                <div
                  class="col-md-12 col-xs-12 col-sm-6"
                  v-if="search_params.product_id != '' && filter_varriants.length > 0 "
                >
                  <div class="form-group">
                    <select class="form-control" v-model="search_params.varriant_id">
                      <option value>{{'All varriants'|translate}}...</option>
                      <option
                        v-for="item in filter_varriants"
                        :value="item.id"
                        :key="item.id"
                      >{{ item.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12 col-xs-12 mt10 mb20">
                  <button type="submit" class="btn btn-success full-width">
                    <i class="fas fa-search"></i>
                    {{'Search'|translate}}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <!-- end col-md-4 -->
          <div class="col-md-9">
            <loading class="mt10" :text="'Please wait'|translate" v-if="list_items ===null"></loading>
            <p
              class="mt10 alert alert-warning"
              v-if="list_items && list_items.length == 0"
            >{{'No result'|translate}}</p>
            <div v-if="list_items && list_items.length >0" class="list-results row">
              <div class="item col-md-6" v-for="item in list_items" :key="item.id">
                <div class="media mb20">
                  <div class="media-left">
                    <img :src="item.product_feature_image" class="media-object" style="width:80px" />
                  </div>
                  <div class="media-body">
                    <h4 class="media-heading">
                      <router-link
                        :to="{ name: 'SaleAdMarketDetail', params: { ad_id: item.id}}"
                      >{{item.varriant_name}}: {{toCommas(item.price)}}/{{item.unit_name}}</router-link>
                    </h4>
                    <p>
                      <i class="fas fa-store-alt"></i>
                      {{item.store_name}}
                    </p>
                    <p>
                      <i class="fas fa-truck"></i>
                      {{item.source_name}} ({{item.source_type|translate}})
                    </p>
                  </div>
                </div>
              </div>
              <!-- end item  -->
            </div>
            <paginate
              v-if="total_page > 1"
              :page-count="total_page"
              :click-handler="clickPage"
              :prev-text="'Prev'|translate"
              :next-text="'Next'|translate"
              v-model="page"
              :container-class="'pagination'"
            ></paginate>
          </div>
          <!-- end col-md-8 -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import Paginate from "vuejs-paginate";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
import FavoriteControl from "@/components/elements/FavoriteControl";
export default {
  name: "SaleMarket",
  components: {
    MyHeader,
    Loading,
    SaleMarketHead,
    Paginate,
    FavoriteControl
  },
  data() {
    let data = {
      list_items: null,
      working: false,
      total_page: 1,
      page: 1,
      store: null,
      allProducts: null,
      varriants: [],
      filter_varriants: [],
      mapProducts: {},
      search_params: {
        store_id: "",
        product_id: "",
        varriant_id: "",
        limit: Utils.getLimit(),
        offset: 0
      }
    };

    return data;
  },

  methods: {
    toCommas(value) {
      return Utils.toCommas(value);
    },
    onSelectProduct() {
      this.search_params.varriant_id = "";
      if (this.search_params.product_id != "") {
        this.filter_varriants = this.varriants.filter(item => {
          return item.product_id == this.search_params.product_id;
        });
      } else {
        this.filter_varriants = [];
      }
    },
    getAllProducts() {
      Utils.getAllProducts(this, {}).then(data => {
        this.allProducts = data;
        this.mapProducts = Utils.arrayToObject(this.allProducts);
      });
    },
    formDoSearch() {
      this.list();
    },
    clickPage(pageNum) {
      this.search_params.offset = Utils.getNextOffset(pageNum);
      this.list();
    },
    list() {
      this.working = true;

      this.list_items = null;

      Utils.request(this, true, "salemarket")
        .get(`/listAds/?${Utils.arrayToRequestParam(this.search_params)}`)
        .then(response => {
          let data = response.data;
          this.working = false;
          if (data.status === "ok") {
            let list = data.data.list;

            this.list_items = list;
            this.total_page = Utils.getTotalPages(data.data.total);
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    listVarriants() {
      Utils.request(this, true, "salemarket")
        .get(`/listVarriants/`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.varriants = data.data;
            if (this.search_params.varriant_id) {
              this.filter_varriants = this.varriants.filter(item => {
                return item.product_id == this.search_params.product_id;
              });
            }
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  },
  mounted() {
    this.search_params.store_id = this.$route.params.store_id;
    if (this.$route.params.product_id) {
      this.search_params.product_id = this.$route.params.product_id;
    }
    if (this.$route.params.varriant_id) {
      this.search_params.varriant_id = this.$route.params.varriant_id;
    }
    let data = {
      offset: 0,
      limit: 1,
      id: this.search_params.store_id
    };
    Utils.request(this, true, "store")
      .get(`/getStore/${this.search_params.store_id}`)
      .then(data => {
        this.store = data.data.data.list[0];
      });

    this.list();
    this.getAllProducts();
    this.listVarriants();
  },
  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleMarketStore.vue